import React from "react"
import { ConfigProvider, Tree } from "antd"
import { useSocket } from "../../../contexts/SocketContext"
const { DirectoryTree } = Tree

const LogsListTree = ({ treeData }) => {
    const { sendMessage } = useSocket()

    const onSelect = (keys) => {
        const [service, id] = keys[0].split("-")

        sendMessage("getLogContent", { service, id })
    }

    const processTreeData = (data) => {
        return data?.map((item) => {
            // If it's a folder (has children), make it non-selectable
            if (item.children && item.children.length > 0) {
                return {
                    ...item,
                    selectable: false, // Make folder non-selectable
                    children: processTreeData(item.children), // Process children recursively
                }
            }
            // If it's a file (no children), keep it selectable
            return {
                ...item,
                selectable: true, // Files are selectable
            }
        })
    }

    return (
        <div dir="rtl" className="col-span-1 mb-5">
            <ConfigProvider
                theme={{
                    components: {
                        Tree: {
                            directoryNodeSelectedBg: "#2d2d2d",
                            nodeSelectedBg: "#fff",
                        },
                    },
                }}
            >
                <DirectoryTree
                    height={1500}
                    className="bg-transparent h-full"
                    style={{ direction: "ltr" }}
                    treeData={processTreeData(treeData)}
                    onSelect={onSelect}
                />
            </ConfigProvider>
        </div>
    )
}
export default LogsListTree
